import { RowWrapper } from "./RowWrapper";
import { TextCell } from "./TextCell";
import { Box, Stack, Typography } from "@mui/material";
import { useAppSelector } from "../../../hooks";

const headerLabelStyle = {
  color: "var(--text-default-caption, #797979)",
  fontFamily: "var(--Family-font-family, Inter)",
  fontSize: "12px",
  fontWeight: 500,
  lineHeight: "14px",
};

const headerCells: {
  label: string;
  minWidth: string;
  maxWidth: string;
  justifyContent?: "flex-start" | "flex-end";
}[] = [
  { label: "Name", minWidth: "120px", maxWidth: "48%" },
  { label: "Seniority", minWidth: "100px", maxWidth: "20%" },
  {
    label: "Engagement",
    minWidth: "124px",
    maxWidth: "12%",
    justifyContent: "flex-end",
  },
  {
    label: "Committee",
    minWidth: "144px",
    maxWidth: "12%",
    justifyContent: "flex-end",
  },
  {
    label: "Cluster",
    minWidth: "104px",
    maxWidth: "12%",
    justifyContent: "flex-end",
  },
];

export const MembersTableHeader = () => {
  const { isEditor } = useAppSelector((state) => state.company.userRoles);

  return (
    <Stack
      flexDirection="row"
      alignItems="center"
      flexGrow={1}
      sx={{
        paddingTop: "8px",
        paddingBottom: "8px",
        borderBottom: "1px solid var(--border-card, #DEDEDE)",
      }}
    >
      {headerCells.map(({ label, minWidth, maxWidth, justifyContent }) => (
        <Stack
          key={label}
          flexDirection="row"
          alignItems="center"
          justifyContent={justifyContent ?? "flex-start"}
          minWidth={minWidth}
          maxWidth={maxWidth}
          width="100%"
          padding="0 16px"
        >
          <Typography sx={headerLabelStyle}>{label}</Typography>
        </Stack>
      ))}
      {isEditor && <Box sx={{ width: "48px", minWidth: "48px" }} />}
    </Stack>
  );
};

export const CompanyRoleTableHeader = () => {
  return (
    <RowWrapper>
      <Box maxWidth={"200px"} minWidth={"200px"}>
        <TextCell
          isHighlighted={true}
          value="Role"
          maxWidth={"200px"}
          minWidth={"200px"}
          tooltip="Probable role of the contact in a buying committee."
        />
      </Box>
      <MembersTableHeader />
    </RowWrapper>
  );
};
